import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import GhlUtmCharts from '../vue_widgets/ghl_utm_charts.vue'

export default class extends Controller {
  static values = {
    connections: Array,
    utmData: Object
  }

  connect() {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    this.vue = createApp(GhlUtmCharts, {
      connections: this.connectionsValue,
      utmData: this.utmDataValue
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
